import Vue from "vue";
import apis from "@/config/api.config.js"
import qs from "qs";
import { ImagePreview } from 'vant';

Vue.use(ImagePreview);

// import {
//     DropdownMenu,
//     DropdownItem,
//     Dialog
// } from 'vant';
// import {
//     Cell,
//     CellGroup
// } from 'vant';
// import {
//     Icon
// } from 'vant';
// import {
//     Search
// } from 'vant';
import {
    Toast
} from 'vant';
// import {
//     Button
// } from 'vant';
// import { Field } from 'vant';

// Vue.use(Field);
// Vue.use(Button);
// Vue.use(Search);
// Vue.use(Icon);
// Vue.use(Cell);
// Vue.use(CellGroup);
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);

export default {
    name: "index",
    data() {

        return {
            activityid: 0,
            value: 0,
            value1: -1,
            value2: '',
            switch1: false,
            switch2: false,
            hasIdentify: false,
            valueable: true,
            curQues: 0,
            btnText: '下一题',
            isChosen: [],
            quesList: [],
            quesReady: false,
            hasFinishQues: false,
            _playAgain: 0,
            usernameShow: false,
            media_status: false,
        };
    },

    methods: {
        imgShow(imgurl) {
            // console.log(imgurl);

            ImagePreview({
                images: [
                    imgurl
                ],
                closeable: true,
              });

        },

        isPlaying() {
            const that = this;
            //如果有播放 直接关闭
            let ques = document.getElementsByClassName("question")
            let ques_type2 = that.quesList[that.curQues].question_type2

            if (ques[that.curQues].children.length && (ques_type2 == "视频题" || ques_type2 == "音频题")) {

                let media = ques[that.curQues].children[0].children[0]
                // console.log(media);

                if (!media.paused) {
                    media.pause()
                }

            }


        },



        // 下提交一题
        toNextQues() {
            const that = this;

            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let count = 0;
            let options = that.quesList[that.curQues].options;

            for (let i = 0; i < options.length; i++) { // 判空 只要有一项选中 count就不为0
                count += options[i].chosen
            }

            if (!count) {
                Toast('请至少选择一项');
                return false
            }

            let type = 1;
            var answer = '';

            for (let i = 0; i < options.length; i++) {
                if (options[i].chosen) {
                    answer += (options[i].key + ',')
                }
            }
            answer = answer.substring(0, answer.length - 1);
            console.log(answer);
            console.log(type);

            let post_data = {
                token: localStorage.getItem('luoohutoken'),
                value: answer,
                type,
                id: that.quesList[that.curQues].id

            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.mark,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    res = res.data;
                    that.isPlaying()
                    Toast.clear();
                    Toast({
                        message: res.msg,
                        forbidClick: true,
                        duration: 2000,
                        onClose: function () {

                            that.curQues++;
                            if (that.curQues == that.quesList.length - 1) {
                                that.btnText = '提 交';

                            }

                            if (that.curQues == that.quesList.length) {
                                let toast = Toast.loading({
                                    duration: 0, // 持续展示 toast
                                    forbidClick: true,
                                    message: '加载中...',
                                });
                                let post_data = {
                                    token: localStorage.getItem('luoohutoken'),
                                    type: that.type

                                };
                                that.axios({
                                    method: "post",
                                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                                    // url: apis.getActivityList,
                                    url: apis.getMark,
                                    data: qs.stringify(post_data),
                                })
                                    .then((res) => {
                                        res = res.data;
                                        Toast.clear();
                                        console.log(res);
                                        that.score = res.data;
                                        that.hasFinishQues = true;
                                        console.log(res.status);
                                        // res.status = "error";
                                        that.$router.replace({ name: "Result", params: { status: res.status, activityid: that.activityid } });
                                    })
                                    .catch((rej) => {
                                        console.log(rej);
                                    });
                            }
                        }
                    })
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },

        onChoose(index) {
            const that = this;

            let type = that.quesList[that.curQues].question_type;
            let options = that.quesList[that.curQues].options;
            if (options[index].chosen) { // 若已选中 取消选中
                options[index].chosen = 0
            } else { // 若未选中 
                if (type == '多选题') {
                    options[index].chosen = 1

                } else {

                    for (let i = 0; i < options.length; i++) {
                        options[i].chosen = 0
                    }
                    options[index].chosen = 1

                }
            }


        },
        // 获取答题列表
        getQuestions() {
            const that = this;
            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let post_data = {
                token: localStorage.getItem('luoohutoken'),
                again: that._playAgain

            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.getQuesList,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    console.log(res);
                    res = res.data;
                    if (res.status == 200) {
                        that.activityid = res.code["activity"]["id"];
                        // console.log(activityid);

                        for (let i = 0; i < res.data.length; i++) {
                            var options = [];
                            var obj = res.data[i];
                            for (let key in obj) {
                                if (key.indexOf('option') > -1) {
                                    options.push({
                                        key: key.replace('option', ''),
                                        value: obj[key] ? obj[key].split('.')[1] : null,
                                        chosen: 0
                                    })
                                }
                            };
                            obj['options'] = options;
                            res.data[i] = obj;
                        }
                        // console.log('res.data', res.data);
                        that.quesList = res.data;
                        Toast.clear()
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },




        playAgain(again) {

            this.hasFinishQues = false;

            this.curQues = 0;
            this.btnText = '下一题';
            this._playAgain = again;
            console.log(this._playAgain);
            this.getQuestions();
        },

        // toRank() {
        //     this.$router.replace({
        //         name: 'rank',
        //         query: {
        //             id: this.id,
        //             type: 0
        //         }
        //     })
        // },

    },
    created() {
        const that = this;
        that.id = that.$route.query.id;
        that.type = 1;
        that._playAgain = that.$route.query.again;
        console.log(that._playAgain);

    },
    mounted() {
        const that = this;
        that.getQuestions();

    },
};